// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'plug-connect';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M4.506 13.494a3.02 3.02 0 0 0 4.27 0l1.063-1.062-4.271-4.27-1.062 1.061a3.02 3.02 0 0 0 0 4.27zm9.038-9.038a3.02 3.02 0 0 0-4.27 0L8.211 5.517l4.27 4.271 1.062-1.061a3.02 3.02 0 0 0 0-4.271zM9.395 6.7l-1.13 1.13m3.035.775-1.13 1.13m-5.664 3.759-3.35 3.35M16.844 1.156l-3.3 3.3'
  />
);

export const viewBox = '0 0 18 18';
